<!-- ProductImages.vue -->
<template>
  <div class="product-images">
    <div
      class="image-container"
      @mousemove="zoom"
      @mouseleave="resetZoom"
      ref="imageContainer"
    >
      <img :src="currentImage" ref="image" />
    </div>

    <!-- Thumbnail Images -->
    <div class="thumbnails" v-if="thumbnails && thumbnails.length > 0">
      <img
        v-for="(thumbnail, index) in thumbnails"
        :key="index"
        :src="thumbnail"
        @click="selectImage(index)"
        :class="{ active: currentIndex === index }"
        class="thumbnail-image"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductImages',
  props: {
    images: {
      type: Array,
      default: () => [],
    },
    thumbnails: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      currentIndex: 0,
      scale: 2, // Zoom scale factor
    };
  },
  computed: {
    currentImage() {
      return this.images[this.currentIndex] || '';
    },
  },
  methods: {
    selectImage(index) {
      this.currentIndex = index;
    },
    zoom(event) {
      const image = this.$refs.image;
      const container = this.$refs.imageContainer;

      const { left, top, width, height } = container.getBoundingClientRect();
      const x = ((event.clientX - left) / width) * 100;
      const y = ((event.clientY - top) / height) * 100;

      image.style.transformOrigin = `${x}% ${y}%`;
      image.style.transform = `scale(${this.scale})`;
    },
    resetZoom() {
      const image = this.$refs.image;
      image.style.transform = 'scale(1)';
      image.style.transformOrigin = 'center center';
    },
  },
};
</script>

<style scoped>
.product-images {
  text-align: center;
}

.image-container {
  width: 100%;
  max-width: 400px;
  height: auto;
  margin: 0 auto;
  overflow: hidden;
  position: relative;
}

.image-container img {
  width: 100%;
  height: auto;
  transition: transform 0.2s ease;
}

.thumbnails {
  margin-top: 10px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}

.thumbnail-image {
  width: 60px;
  height: 60px;
  object-fit: cover;
  margin: 5px;
  cursor: pointer;
  border: 2px solid transparent;
}

.thumbnail-image.active,
.thumbnail-image:hover {
  border-color: #e67e22;
}
</style>